import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { FaEnvelope, FaLinkedin } from "react-icons/fa";

function Contact() {

  const form = useRef();
  const [sent, setSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "YOUR_SERVICE_ID",
        "YOUR_TEMPLATE_ID",
        form.current,
        "YOUR_PUBLIC_KEY"
      )
      .then(
        () => {
          setSent(true);
          form.current.reset();
        },
        () => {
          alert("Failed to send message.");
        }
      );
  };

  return (
    <section className="min-h-screen bg-gradient-to-br from-[#0b1220] via-[#0f1d3a] to-[#0a1f44] text-white pt-40 pb-20">

      <div className="max-w-5xl mx-auto px-6">

        {/* Title */}

        <h1 className="text-4xl font-bold text-center mb-4">
          Contact Me
        </h1>

        <p className="text-center text-gray-400 mb-12">
          Let's build something amazing together
        </p>


        {/* Contact Card */}

        <div className="bg-[#1b2433]/90 backdrop-blur-md rounded-2xl p-10 shadow-[0_0_50px_rgba(59,130,246,0.25)]">

          {/* Contact Info */}

          <div className="flex flex-col md:flex-row justify-center gap-10 text-center mb-10">

            <a
              href="mailto:diyajacob.tech@gmail.com"
              className="flex items-center gap-3 justify-center hover:text-blue-400 transition"
            >
              <FaEnvelope />
              diyajacob.tech@gmail.com
            </a>

            <a
              href="https://www.linkedin.com/in/diya-jacob-34547818a/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 justify-center hover:text-blue-400 transition"
            >
              <FaLinkedin />
              LinkedIn Profile
            </a>

          </div>


          {/* Contact Form */}

          <form
            ref={form}
            onSubmit={sendEmail}
            className="space-y-6 max-w-2xl mx-auto"
          >

            {/* Name */}

            <input
              type="text"
              name="user_name"
              placeholder="Your Name"
              required
              className="w-full p-4 rounded-lg bg-[#0f172a] border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />


            {/* Email */}

            <input
              type="email"
              name="user_email"
              placeholder="Your Email"
              required
              className="w-full p-4 rounded-lg bg-[#0f172a] border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />


            {/* Message */}

            <textarea
              name="message"
              placeholder="Your Message"
              rows="5"
              required
              className="w-full p-4 rounded-lg bg-[#0f172a] border border-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />


            {/* Button */}

            <button
              type="submit"
              className="w-full py-3 rounded-lg font-semibold bg-gradient-to-r from-blue-500 to-indigo-500 hover:opacity-90 transition"
            >
              Send Message
            </button>


            {/* Success Message */}

            {sent && (
              <p className="text-green-400 text-center mt-4">
                Message sent successfully ✔
              </p>
            )}

          </form>

        </div>

      </div>

    </section>
  );
}

export default Contact;